/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import { Dialog } from "office-ui-fabric-react";
import PropTypes from "prop-types";
import { useRef } from "react";

const styles = {
  secondaryBtn: {
    width: "auto",
    height: "auto",
    backgroundColor: "#dddddd",
    padding: "8px 18px",
    fontSize: "14px",
    border: "0 !important",
    color: "black",
    borderRadius: "30px",
    marginLeft: "10px",
    ":hover": {
      backgroundColor: "#cccccc",
      color: "black",
    },
    "@media (max-width: 480px)": {
      padding: "7px 14px",
      fontSize: "12px",
    },
  },
  downloadText: {
    border: "0 !important",
    color: "#288bd0",
    fontSize: "14px",
    marginRight: "10px",
    ":hover": {
      color: "#0a58ca",
      textDecoration: "underline",
    },
    "@media (max-width: 480px)": {
      fontSize: "12px",
    },
  },
};
const dialogStyles = {
  medium: {
    main: {
      selectors: {
        "@media (min-width: 620px)": {
          width: 600,
          minWidth: 450,
          maxWidth: 600,
          maxHeight: "100%",
        },
      },
    },
  },
};
const EcsFormsDownload = ({ showDialog, closeDialog }) => {
  const intervalIdRef = useRef(null);
  const files = [
    "https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/04.How%20offline%20ECS%20Form%20works%20and%20what%20should%20be%20done%20after%20filling%20the%20form.pdf",
    "https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/03.Instructions%20for%20filling%20of%20ECS.pdf",
    "https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/02.Example%20of%20a%20filled%20ECS%20Form.pdf",
    "https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/01.ECS%20Form-Final.pdf",
  ];
  const urlsRef = useRef([...files]);

  const download = () => {
    const url = urlsRef.current.pop();

    if (url) {
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", "");
      a.setAttribute("target", "_blank");
      a.click();
    }

    if (urlsRef.current.length === 0) {
      clearInterval(intervalIdRef.current);
    }
  };

  const openFilesInTabs = () => {
    urlsRef.current = [...files];
    const newIntervalId = setInterval(download, 300);
    intervalIdRef.current = newIntervalId;
  };

  return (
    <Box className="contact-us-buttons downloadDialog" sx={{ padding: "1rem" }}>
      <Dialog
        isOpen={showDialog}
        hidden={!showDialog}
        onDismiss={closeDialog}
        styles={dialogStyles.medium}
        title="Download ECS Forms (Offline)"
      >
        <p>
          <a
            href="https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/01.ECS%20Form-Final.pdf"
            target="_blank"
            sx={{
              "&:hover": {
                textDecoration: "underline !important",
              },
            }}
            rel="noreferrer"
          >
            ECS Form
          </a>
        </p>
        <p>
          <a
            href="https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/02.Example%20of%20a%20filled%20ECS%20Form.pdf"
            target="_blank"
            sx={{
              "&:hover": {
                textDecoration: "underline !important",
              },
            }}
            rel="noreferrer"
          >
            Sample Filled ECS Form
          </a>
        </p>
        <p>
          <a
            href="https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/03.Instructions%20for%20filling%20of%20ECS.pdf"
            target="_blank"
            sx={{
              "&:hover": {
                textDecoration: "underline !important",
              },
            }}
            rel="noreferrer"
          >
            Instruction to Fill ECS form
          </a>
        </p>
        <p>
          <a
            href="https://cdn-prod.heartfulness.org/donations-doc/recurring_offline/04.How%20offline%20ECS%20Form%20works%20and%20what%20should%20be%20done%20after%20filling%20the%20form.pdf"
            target="_blank"
            sx={{
              "&:hover": {
                textDecoration: "underline !important",
              },
            }}
            rel="noreferrer"
          >
            How offline ECS Form works and what should be done after filling the
            form
          </a>
        </p>
        <div className="d-flex justify-content-end align-items-center">
          <box
            role="button"
            sx={styles.downloadText}
            onClick={openFilesInTabs}
            onKeyDown={openFilesInTabs}
          >
            Download All
          </box>
          <box
            role="button"
            sx={styles.secondaryBtn}
            onClick={() => closeDialog()}
            onKeyDown={() => closeDialog()}
          >
            Close
          </box>
        </div>
      </Dialog>
    </Box>
  );
};

EcsFormsDownload.propTypes = {
  showDialog: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
};
export default EcsFormsDownload;
